import * as React from "react";

import "./dev-temp.scss";

import {cs}              from "@Common/react/chain-services";
import {UseState}        from "@Common/react/use-state";
import {DatePicker2}     from "@Common/ui-components/date-picker-2/date-picker-2";
import {addDate, today}  from "@Common/utils/date-object";
import {parseDateFormat} from "@Common/utils/date/parse-date-format";

import {Layout} from "../layout/layout";

export const DevTemp = ({}) => cs(
    ({}, next) => Layout({
        // className: "customize-layout-95r",
        children: next(),
    }),
    ["d1", (_, next) => UseState({
        initValue: today(),
        next,
    })],

    ({d1}) => (
        <div className="dev-temp-91a">
            {/*{DateRangePicker({*/}
            {/*    onSearch: (dates) => {*/}
            {/*        console.log("dates", dates);*/}
            {/*    },*/}
            {/*})}*/}

            {DatePicker2({
                className: "",
                hasError: false,
                state: d1,
                dateFormat: parseDateFormat("yyyy-mm-dd"),
                minDate: addDate(today(), 10),
                maxDate: addDate(today(), 365),
                // isDisabled: (d) => true,
            })}

            <pre>{JSON.stringify(d1.value, null, 4)}</pre>

            {/*{parseDateFormat("yyyy-mm-dd").parseDate("2010-02-29")}*/}
        </div>
    ),
);
